import { render, staticRenderFns } from "./EditorCompleteStageButton.vue?vue&type=template&id=ab4ef1e2&scoped=true&"
import script from "./EditorCompleteStageButton.vue?vue&type=script&lang=js&"
export * from "./EditorCompleteStageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4ef1e2",
  null
  
)

export default component.exports